import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Steps from '../components/Steps';
import Ecosystem from '../components/Ecosystem';
import WhySilver from '../components/WhySilver';
import SilverAdvantage from '../components/SilverAdvantage';
import Rewards from '../components/Rewards';
import BaliPrize from '../components/BaliPrize';
import Fairness from '../components/Fairness';
import Countdown from '../components/Countdown';
import Faq from '../components/Faq';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="relative overflow-x-hidden">
      <Navbar />
      <Hero />
      <WhySilver />
      <Steps />
      <Ecosystem />
      <SilverAdvantage />
      <Rewards />
      <BaliPrize />
      <Fairness />
      <Countdown />
      <Faq />
      <Footer />
    </div>
  );
}
